/* LithiumPro UI – effekter og funktioner til egne sektioner (FAQ, faneblade, tidslinje, scroll-animationer) */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim(); }
  function raf(fn) { var t = false; return function () { if (t) return; t = true; w.requestAnimationFrame(function () { t = false; fn(); }); }; }

  /* ---------- Fast (sticky) menu: kræver at body/#root ikke klipper ---------- */
  function stickyNav(el) {
    var sec = el.closest('.shopify-section') || el;
    sec.classList.add('lp-is-sticky');
    d.body.classList.add('lp-has-sticky');
    return sec;
  }
  function stickyOffset() {
    var off = 0;
    $$('.lp-is-sticky').forEach(function (s) { var r = s.getBoundingClientRect(); if (r.top <= 1) off = Math.max(off, r.bottom); else off = Math.max(off, r.height); });
    return off;
  }
  function scrollToEl(el, smooth) {
    var y = el.getBoundingClientRect().top + w.pageYOffset - stickyOffset() - 14;
    w.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduce ? 'smooth' : 'auto' });
  }
  w.lpScrollTo = scrollToEl;

  /* ---------- Glidende åbning af spørgsmål ---------- */
  function initDetails(root) {
    $$('details.lp-q', root).forEach(function (det) {
      if (det.dataset.lpInit) return; det.dataset.lpInit = '1';
      var sum = det.querySelector('summary'), body = det.querySelector('.lp-a');
      if (!sum || !body) return;
      sum.addEventListener('click', function (e) {
        if (reduce || !body.animate) return;
        e.preventDefault();
        if (det._anim) det._anim.cancel();
        if (!det.open) {
          det.open = true;
          var h = body.scrollHeight;
          det._anim = body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
        } else {
          var h2 = body.scrollHeight;
          det._anim = body.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'ease-in' });
          det._anim.onfinish = function () { det.open = false; };
        }
      });
    });
  }
  function openQuestion(id, smooth) {
    var q = d.getElementById(id);
    if (!q || !q.classList.contains('lp-q')) return false;
    var g = q.closest('.lp-faqgroup');
    if (g && g.classList.contains('is-hidden')) clearSearch();
    q.open = true;
    scrollToEl(q, smooth);
    q.classList.remove('is-flash'); void q.offsetWidth; q.classList.add('is-flash');
    return true;
  }

  /* ---------- FAQ: søgning, emnemenu, emne-kort, scroll-spy ---------- */
  var clearSearch = function () {};
  function initFaq() {
    var groups = $$('[data-lp-faq-group]');
    if (!groups.length) return;
    initDetails(d);
    var total = $$('.lp-q').length;
    $$('[data-lp-total]').forEach(function (el) { el.textContent = total; });

    var nav = d.querySelector('[data-lp-faqnav]');
    var chipsBox = d.querySelector('[data-lp-faq-chips]');
    var cats = d.querySelector('[data-lp-faq-cats]');
    var chips = [];
    groups.forEach(function (g) {
      var icon = g.querySelector('[data-lp-icon]');
      var title = g.getAttribute('data-title') || (g.querySelector('h2') || {}).textContent || '';
      var n = $$('.lp-q', g).length;
      if (chipsBox) {
        var a = d.createElement('a');
        a.className = 'lp-chip'; a.href = '#' + g.id; a.setAttribute('data-target', g.id);
        a.innerHTML = (icon ? icon.innerHTML : '') + '<span></span>';
        a.querySelector('span').textContent = title;
        chipsBox.appendChild(a); chips.push(a);
      }
      if (cats) {
        var c = d.createElement('a');
        c.className = 'lp-cat'; c.href = '#' + g.id; c.setAttribute('data-target', g.id);
        c.innerHTML = '<span class="lp-ico">' + (icon ? icon.innerHTML : '') + '</span><span><b></b><small></small></span>';
        c.querySelector('b').textContent = title;
        c.querySelector('small').textContent = n + ' spørgsmål';
        cats.appendChild(c);
      }
    });
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.lp-chip, .lp-cat, [data-lp-q-link]');
      if (!a) return;
      var id = (a.getAttribute('href') || '').replace(/^#/, '');
      if (a.hasAttribute('data-lp-q-link')) { if (openQuestion(id, true)) { e.preventDefault(); history.replaceState && history.replaceState(null, '', '#' + id); } return; }
      var g = d.getElementById(id);
      if (g) { e.preventDefault(); scrollToEl(g, true); history.replaceState && history.replaceState(null, '', '#' + id); }
    });

    var navSec = nav ? stickyNav(nav) : null;
    var progress = nav ? nav.querySelector('.lp-progress i') : null;
    var active = null;
    var spy = raf(function () {
      var line = stickyOffset() + Math.max(90, w.innerHeight * 0.28), cur = null;
      groups.forEach(function (g) { if (!g.classList.contains('is-hidden') && g.getBoundingClientRect().top <= line) cur = g; });
      if (cur !== active) {
        active = cur;
        chips.forEach(function (c) {
          var on = cur && c.getAttribute('data-target') === cur.id;
          c.classList.toggle('is-active', !!on);
          if (on && chipsBox) {
            var left = c.offsetLeft - (chipsBox.clientWidth - c.offsetWidth) / 2;
            chipsBox.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
          }
        });
      }
      if (progress) {
        var first = groups[0].getBoundingClientRect().top + w.pageYOffset;
        var last = groups[groups.length - 1];
        var end = last.getBoundingClientRect().bottom + w.pageYOffset - w.innerHeight;
        var p = (w.pageYOffset - first + line) / Math.max(1, end - first + line);
        progress.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(4));
      }
    });
    w.addEventListener('scroll', spy, { passive: true });
    w.addEventListener('resize', spy);
    spy();

    /* søgning */
    var input = d.querySelector('[data-lp-faq-input]');
    var status = d.querySelector('[data-lp-faq-status]');
    var clearBtn = d.querySelector('[data-lp-faq-clear]');
    var form = input ? input.closest('.lp-search') : null;
    var empty = null;
    if (nav && navSec) {
      empty = d.createElement('div');
      empty.className = 'lp-sec lp-bg-white lp-empty';
      empty.innerHTML = '<div class="lp-wrap"><span class="lp-ico">' + (nav.querySelector('.lp-faqnav__search') || {}).innerHTML + '</span><h3></h3><p></p><div class="lp-btns" style="justify-content:center"><a class="lp-btn lp-btn-primary"></a></div></div>';
      empty.querySelector('h3').textContent = nav.getAttribute('data-empty-title') || '';
      empty.querySelector('p').textContent = nav.getAttribute('data-empty-text') || '';
      var eb = empty.querySelector('a');
      eb.textContent = nav.getAttribute('data-empty-btn') || ''; eb.href = nav.getAttribute('data-empty-url') || '#';
      navSec.parentNode.insertBefore(empty, navSec.nextSibling);
    }
    var items = $$('.lp-q').map(function (q) {
      var span = q.querySelector('summary > span');
      return { q: q, span: span, html: span ? span.innerHTML : '', text: norm(q.textContent) };
    });
    function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function run() {
      var raw = input.value.trim(), terms = norm(raw).split(' ').filter(function (t) { return t.length > 1; });
      if (form) form.classList.toggle('has-q', raw.length > 0);
      var hits = 0;
      items.forEach(function (it) {
        var ok = !terms.length || terms.every(function (t) { return it.text.indexOf(t) > -1; });
        it.q.classList.toggle('is-hidden', !ok);
        it.q.classList.toggle('is-hit', ok && terms.length > 0);
        if (it.span) {
          if (ok && terms.length) {
            var re = new RegExp('(' + terms.map(esc).join('|') + ')', 'gi');
            it.span.innerHTML = it.html.replace(/>([^<]*)</g, function (m, txt) { return '>' + txt.replace(re, '<mark>$1</mark>') + '<'; }).replace(/^([^<]*)/, function (m, txt) { return txt.replace(re, '<mark>$1</mark>'); });
          } else it.span.innerHTML = it.html;
        }
        if (ok) hits++;
      });
      groups.forEach(function (g) {
        var vis = $$('.lp-q:not(.is-hidden)', g).length;
        g.classList.toggle('is-hidden', vis === 0);
        var chip = chips.filter(function (c) { return c.getAttribute('data-target') === g.id; })[0];
        if (chip) chip.classList.toggle('is-empty', vis === 0);
      });
      if (empty) empty.classList.toggle('is-on', terms.length > 0 && hits === 0);
      if (status) {
        if (!terms.length) status.textContent = '';
        else if (hits) status.textContent = (status.getAttribute('data-tpl-hits') || '{n}').replace('{n}', hits);
        else status.textContent = status.getAttribute('data-tpl-none') || '';
      }
      spy();
    }
    clearSearch = function () { if (!input) return; input.value = ''; run(); };
    if (input) {
      var t;
      input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 120); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault(); run();
          var first = items.filter(function (it) { return !it.q.classList.contains('is-hidden'); })[0];
          if (first && input.value.trim()) { first.q.open = true; scrollToEl(first.q, true); }
        } else if (e.key === 'Escape') { clearSearch(); }
      });
    }
    if (clearBtn) clearBtn.addEventListener('click', function () { clearSearch(); input.focus(); });
    var focusBtn = d.querySelector('[data-lp-faq-focus]');
    if (focusBtn && input) focusBtn.addEventListener('click', function () {
      w.scrollTo({ top: Math.max(0, input.getBoundingClientRect().top + w.pageYOffset - 160), behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    });

    /* link med #spørgsmål eller #emne ved indlæsning */
    function fromHash() {
      var h = decodeURIComponent((location.hash || '').slice(1));
      if (!h || !/^[a-z0-9_-]+$/i.test(h)) return;
      if (!openQuestion(h, false)) { var g = d.getElementById(h); if (g && g.hasAttribute('data-lp-faq-group')) scrollToEl(g, false); }
    }
    w.addEventListener('load', function () { setTimeout(fromHash, 120); });
  }

  /* ---------- Hop-til-menu i brugsvejledning (lp-anchor-nav) ---------- */
  function initAnchorNav() {
    var navEl = d.querySelector('.lp-anchor-nav');
    if (!navEl) return;
    stickyNav(navEl);
    var links = $$('a[data-lp-target]', navEl);
    var targets = links.map(function (a) { var k = a.getAttribute('data-lp-target'); return d.getElementById(k) || d.querySelector('[id$="__' + k + '"]'); });
    var ul = navEl.querySelector('ul');
    var active = -1;
    var spy = raf(function () {
      var line = stickyOffset() + Math.max(90, w.innerHeight * 0.28), cur = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) cur = i; });
      if (cur !== active) {
        active = cur;
        links.forEach(function (a, i) {
          a.classList.toggle('is-active', i === cur);
          if (i === cur && ul && ul.scrollWidth > ul.clientWidth) ul.scrollTo({ left: Math.max(0, a.offsetLeft - (ul.clientWidth - a.offsetWidth) / 2), behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    });
    w.addEventListener('scroll', spy, { passive: true });
    spy();
  }

  /* ---------- Faneblade ---------- */
  function initTabs() {
    $$('[data-lp-tabs]').forEach(function (box) {
      var tabs = $$('[role="tab"]', box);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab, p = d.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (p) { p.hidden = !on; p.classList.toggle('is-in', on); }
        });
        if (focus) tab.focus();
        var nav = tab.parentNode;
        if (nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: Math.max(0, tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2), behavior: reduce ? 'auto' : 'smooth' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      if (design) d.addEventListener('shopify:block:select', function (e) {
        var p = e.target.closest && e.target.closest('[role="tabpanel"]');
        if (p && box.contains(p)) { var t = d.getElementById(p.getAttribute('aria-labelledby')); if (t) select(t, false); }
      });
    });
  }

  /* ---------- Tidslinje ---------- */
  function initTimeline() {
    $$('[data-lp-timeline]').forEach(function (list) {
      var items = $$('.lp-tl__item', list);
      var upd = raf(function () {
        var r = list.getBoundingClientRect(), mid = w.innerHeight * 0.62;
        var p = (mid - r.top) / Math.max(1, r.height);
        list.style.setProperty('--lp-tl', Math.max(0, Math.min(1, p)).toFixed(4));
        items.forEach(function (it) { it.classList.toggle('is-on', it.getBoundingClientRect().top < mid); });
      });
      w.addEventListener('scroll', upd, { passive: true });
      w.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- Scroll-animationer på hele siden ---------- */
  function initReveal() {
    if (reduce || design || !('IntersectionObserver' in w)) return;
    var vh = w.innerHeight;
    var secs = $$('main#content > .shopify-section').filter(function (s) {
      var id = s.id || '';
      if (id.indexOf('template--') === -1) return false;          /* kun skabelonens sektioner, ikke header/footer */
      if (/__main(\b|[-_])/i.test(id) || /__main$/.test(id)) return false; /* hovedsektioner (produkt, kollektion, kurv) */
      if (s.querySelector('.lp-faqnav, .lp-anchor-nav, form[action*="/cart"], [class*="sticky"]')) return false;
      return s.getBoundingClientRect().top > vh * 0.92;           /* kun det, der ligger under skærmkanten */
    });
    if (!secs.length) return;
    d.documentElement.classList.add('lp-anim');
    var wide = w.innerWidth > 760;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('lp-in');
        $$('.lp-stagger', en.target).forEach(function (s) { s.classList.add('lp-in'); });
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    secs.forEach(function (s) {
      s.classList.add('lp-reveal');
      if (wide) $$('[data-lp-stagger], ul.l4st, ul.l4cu, .lp-cats', s).forEach(function (list) {
        if (list.closest('.swiper, [class*="slider"]') && !list.matches('ul.l4st')) return;
        list.classList.add('lp-stagger');
        Array.prototype.forEach.call(list.children, function (c, i) { c.style.setProperty('--i', Math.min(i, 10)); });
      });
      io.observe(s);
    });
    /* sikkerhedsnet: vis alt ved udskrift */
    w.addEventListener('beforeprint', function () { secs.forEach(function (s) { s.classList.add('lp-in'); }); });
  }

  /* ---------- Temaets tællere: dansk decimalkomma (4.8 -> 4,8) – kun efter tælle-animationen ---------- */
  function initCounters() {
    if (!('MutationObserver' in w) || !w.WeakMap) return;
    var ran = new WeakMap();
    $$('ul.l4cu').forEach(function (ul) {
      var t = null;
      var fix = function () {
        $$('span.clone[data-val]', ul).forEach(function (el) {
          var s = el.textContent;
          if (!ran.get(el) || el.children.length || s !== el.getAttribute('data-val')) return;
          if (/^\s*\d+\.\d{1,2}\s*$/.test(s)) el.textContent = s.replace('.', ',');
        });
      };
      new MutationObserver(function () {
        $$('span.clone[data-val]', ul).forEach(function (el) { if (el.textContent !== el.getAttribute('data-val')) ran.set(el, true); });
        clearTimeout(t); t = setTimeout(fix, 700);
      }).observe(ul, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    try { initCounters(); } catch (e) { console.warn('lp counters', e); }
    try { initFaq(); } catch (e) { console.warn('lp faq', e); }
    try { initAnchorNav(); } catch (e) { console.warn('lp nav', e); }
    try { initTabs(); } catch (e) { console.warn('lp tabs', e); }
    try { initTimeline(); } catch (e) { console.warn('lp tl', e); }
    try { initReveal(); } catch (e) { console.warn('lp reveal', e); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
